/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum DigitalAccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  INCOMPLETE = "INCOMPLETE",
  SETUP = "SETUP",
  UNKNOWN = "UNKNOWN",
}

/**
 * Represents a type of origin system this account belongs to.
 */
export enum DigitalAccountType {
  BROADBAND = "BROADBAND",
  KRAKEN = "KRAKEN",
  LPG = "LPG",
  OHM = "OHM",
  SAP = "SAP",
  SUPERLOOP = "SUPERLOOP",
  UNKNOWN = "UNKNOWN",
  VPP = "VPP",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
